module.exports = "/images/ec.svg?cccaebc5b4758dedf12603db0e5d8ba1";